export const ACADEMIC_YEARS = '/academic-years'
